<template>
    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Change {{ userData.name }}'s Email Address</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4" v-if="userData !== null">

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Email Address
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" type="text" v-model="email">
                </div>

            </div>

             <!-- footer -->
            <div class="mt-10 clearfix">
                <!-- @click="addAnnouncement()" -->
                <button v-on:click="displayModal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                    Cancel
                </button>
                <button v-on:click="submitEmail" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                    Update Email Address
                </button>
            </div>

        </div>
    </Modal>
</template>

<script>
    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';
    import Modal from '@/components/Modal'

    export default {
        data() {
            return {
                displayModal: false,
                userData: {},
                resetType: null,
                email: null,
                loading: false,
            }
        },

        components: {
            Modal
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('change-user-email-open-modal', this.open);
            }.bind(this));
        },

        destroyed() {
            EventBus.$off('change-user-email-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            open(data) {
                this.displayModal = true
                this.userData = data
                this.email = data.email
            },

            submitEmail() {
                var _this = this;
                this.loading = true;
                this.$http.post(Config.apiPath + "/api/v2/admin/users/" + this.userData.id + "/email", { email: this.email }, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {
                        _this.loading = false;
                        _this.displayModal = false
                        EventBus.$emit('admin-user-data-refresh');
                    }
                });
            }
        }
        
    }
</script>
